export const categories = [
  { id: "action", name: "动作片", slug: "action", description: "紧张刺激的动作电影，拳拳到肉的精彩打斗" },
  { id: "comedy", name: "喜剧片", slug: "comedy", description: "欢乐搞笑的喜剧电影，让你开怀大笑" },
  { id: "romance", name: "爱情片", slug: "romance", description: "浪漫动人的爱情故事，感人至深的情感" },
  { id: "sci-fi", name: "科幻片", slug: "sci-fi", description: "脑洞大开的科幻巨制，探索未知的宇宙" },
  { id: "horror", name: "恐怖片", slug: "horror", description: "惊心动魄的恐怖电影，挑战你的胆量" },
  { id: "animation", name: "动画片", slug: "animation", description: "精良制作的动画电影，适合全家人观看" },
  { id: "drama", name: "剧情片", slug: "drama", description: "深刻动人的剧情电影，引人思考的故事" },
  { id: "tv-series", name: "电视剧", slug: "tv-series", description: "精彩纷呈的电视剧集，追剧停不下来" },
];

export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    category: "sci-fi",
    year: 2026,
    rating: 9.2,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20planetary%20engines%20against%20a%20cosmic%20backdrop%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20blue%20and%20orange%20tones%2C%20epic%20scale%2C%20movie%20poster%20style%20with%20Chinese%20title%20text%20space&width=400&height=600&seq=movie-card-01&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，一群勇敢的年轻人挺身而出，展开了一场跨越时空的救援行动。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    duration: "148分钟",
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: "封神第二部",
    category: "action",
    year: 2026,
    rating: 8.8,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%20featuring%20ancient%20warriors%20in%20elaborate%20armor%20with%20mythical%20beasts%2C%20dramatic%20Chinese%20mythology%20aesthetic%2C%20golden%20and%20crimson%20color%20palette%2C%20theatrical%20composition%20with%20traditional%20Chinese%20elements&width=400&height=600&seq=movie-card-02&orientation=portrait",
    description: "殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐武王伐纣。一场人、仙、妖三界的宏大战争即将拉开序幕，各路英雄豪杰汇聚一堂。",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    duration: "156分钟",
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: "长安十二时辰",
    category: "drama",
    year: 2026,
    rating: 9.0,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20set%20in%20Tang%20Dynasty%20Changan%20city%2C%20ancient%20Chinese%20architecture%20with%20lanterns%20at%20night%2C%20mysterious%20atmosphere%2C%20rich%20warm%20tones%20of%20amber%20and%20gold%2C%20cinematic%20movie%20poster%20with%20Chinese%20calligraphy&width=400&height=600&seq=movie-card-03&orientation=portrait",
    description: "天宝三年，上元节前夕，长安城混入可疑人员。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安城于危难之中。",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围"],
    duration: "48集",
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: "你好，李焕英2",
    category: "comedy",
    year: 2026,
    rating: 8.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20poster%20with%20warm%20family%20scene%2C%20nostalgic%201980s%20Chinese%20setting%2C%20bright%20and%20cheerful%20colors%2C%20soft%20lighting%2C%20heartwarming%20atmosphere%2C%20movie%20poster%20style%20with%20playful%20elements&width=400&height=600&seq=movie-card-04&orientation=portrait",
    description: "贾晓玲意外穿越回过去，再次遇见年轻时的母亲李焕英。这一次，她决定用全新的方式让母亲过上最幸福的生活，展开了一段笑中带泪的温情旅程。",
    director: "贾玲",
    actors: ["贾玲", "张小斐", "沈腾"],
    duration: "132分钟",
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: "暗夜追踪者",
    category: "horror",
    year: 2026,
    rating: 7.8,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20horror%20thriller%20movie%20poster%20with%20dark%20urban%20alley%20at%20night%2C%20mysterious%20shadowy%20figure%2C%20moody%20blue%20and%20black%20tones%20with%20neon%20red%20accents%2C%20suspenseful%20cinematic%20atmosphere%2C%20modern%20city%20horror%20aesthetic&width=400&height=600&seq=movie-card-05&orientation=portrait",
    description: "一座繁华都市的深夜，连环失踪案接连发生。警探陈默在追查过程中，逐渐发现自己也被卷入了一场无法逃脱的黑暗阴谋之中。",
    director: "陈思诚",
    actors: ["刘昊然", "张子枫", "肖央"],
    duration: "118分钟",
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: "深海总动员",
    category: "animation",
    year: 2026,
    rating: 8.9,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20colorful%20underwater%20ocean%20world%2C%20cute%20fish%20characters%20and%20coral%20reefs%2C%20vibrant%20blue%20and%20turquoise%20colors%2C%20magical%20underwater%20lighting%2C%20family-friendly%20animation%20movie%20poster%20style&width=400&height=600&seq=movie-card-06&orientation=portrait",
    description: "在神秘的深海世界，一条勇敢的小丑鱼踏上冒险之旅，寻找传说中的海洋之心。一路上结识了各种有趣的海洋伙伴，共同对抗邪恶的深海霸主。",
    director: "田晓鹏",
    actors: ["杨幂", "黄渤", "周冬雨"],
    duration: "105分钟",
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: "爱情神话2",
    category: "romance",
    year: 2025,
    rating: 8.3,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20romance%20film%20poster%20with%20couple%20walking%20through%20Shanghai%20streets%20at%20golden%20hour%2C%20warm%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20cinematic%20shallow%20depth%20of%20field%2C%20elegant%20modern%20Chinese%20urban%20romance%20aesthetic&width=400&height=600&seq=movie-card-07&orientation=portrait",
    description: "在上海这座充满烟火气的城市里，几对都市男女的爱情故事交织在一起。他们用各自的方式诠释着爱情的真谛，有欢笑也有泪水。",
    director: "邵艺辉",
    actors: ["徐峥", "马伊琍", "吴越"],
    duration: "125分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: "狂飙：黎明之前",
    category: "tv-series",
    year: 2026,
    rating: 9.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20intense%20confrontation%20between%20police%20and%20criminals%2C%20dark%20urban%20night%20setting%2C%20high%20contrast%20noir%20lighting%2C%20dramatic%20tension%2C%20gritty%20realistic%20Chinese%20crime%20thriller%20aesthetic&width=400&height=600&seq=movie-card-08&orientation=portrait",
    description: "扫黑除恶专项斗争进入深水区，刑警安欣与黑恶势力展开最后的较量。在这场正与邪的对决中，无数人的命运将被改写。",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    duration: "40集",
    isHot: true,
    isNew: true,
  },
  {
    id: 9,
    title: "战神纪",
    category: "action",
    year: 2025,
    rating: 8.1,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20action%20war%20movie%20poster%20with%20ancient%20battlefield%2C%20mounted%20warriors%20in%20armor%2C%20dust%20and%20smoke%2C%20epic%20scale%2C%20warm%20earth%20tones%20with%20crimson%20highlights%2C%20heroic%20cinematic%20composition&width=400&height=600&seq=movie-card-09&orientation=portrait",
    description: "蒙古草原上，少年铁木真历经磨难，在战火中成长为一代天骄成吉思汗。他用智慧和勇气统一草原部落，开启了征服世界的传奇征程。",
    director: "哈斯朝鲁",
    actors: ["陈伟霆", "林允", "胡军"],
    duration: "135分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: "星河战队：重生",
    category: "sci-fi",
    year: 2026,
    rating: 8.7,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20space%20opera%20movie%20poster%20with%20futuristic%20spaceship%20fleet%20and%20nebula%2C%20astronauts%20in%20advanced%20suits%2C%20deep%20space%20background%20with%20stars%2C%20cool%20blue%20and%20silver%20tones%2C%20epic%20cinematic%20sci-fi%20composition&width=400&height=600&seq=movie-card-10&orientation=portrait",
    description: "公元2150年，人类星际联盟遭遇外星文明入侵。一支精英战队奉命前往银河边缘执行绝密任务，却在途中发现了关于人类起源的惊天秘密。",
    director: "吴京",
    actors: ["吴京", "张涵予", "朱一龙"],
    duration: "142分钟",
    isHot: false,
    isNew: true,
  },
  {
    id: 11,
    title: "大明风华录",
    category: "tv-series",
    year: 2025,
    rating: 8.6,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20drama%20TV%20series%20poster%20with%20imperial%20court%20setting%2C%20elegant%20traditional%20costumes%2C%20Ming%20Dynasty%20aesthetic%2C%20rich%20red%20and%20gold%20palette%2C%20solemn%20composition%20with%20Chinese%20palace%20architecture&width=400&height=600&seq=movie-card-11&orientation=portrait",
    description: "明成祖朱棣时期，永乐盛世下暗流涌动。一位普通女子阴差阳错进入皇宫，在权力与情感的漩涡中寻找自己的命运。宫廷权谋与人性的深刻交织。",
    director: "张挺",
    actors: ["汤唯", "朱亚文", "邓家佳"],
    duration: "55集",
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: "笑傲江湖之东方不败",
    category: "action",
    year: 2026,
    rating: 9.1,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20film%20poster%20with%20sword-wielding%20hero%20in%20flowing%20robes%2C%20mountain%20landscape%20with%20mist%2C%20dramatic%20Chinese%20ink%20painting%20style%2C%20red%20and%20black%20color%20contrast%2C%20epic%20wuxia%20cinematic%20poster&width=400&height=600&seq=movie-card-12&orientation=portrait",
    description: "日月神教教主东方不败练成葵花宝典，武功冠绝天下。令狐冲在江湖恩怨中周旋，与东方不败展开了一场亦敌亦友的传奇对决。",
    director: "徐克",
    actors: ["林青霞", "李连杰", "关之琳"],
    duration: "128分钟",
    isHot: true,
    isNew: false,
  },
];

export const featuredCollections = [
  {
    id: 1,
    title: "2026年度必看大片",
    description: "精选本年度最受期待的院线大片，每一部都不容错过",
    movieIds: [1, 2, 8, 10],
    imageUrl: "https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20the%20best%20Chinese%20movies%20of%202026%2C%20golden%20film%20reel%20and%20award%20elements%2C%20elegant%20premium%20design%2C%20dark%20background%20with%20gold%20accents%2C%20prestigious%20movie%20collection%20aesthetic&width=800&height=400&seq=collection-01&orientation=landscape",
  },
  {
    id: 2,
    title: "经典重温：武侠传奇",
    description: "重温那些年我们一起追过的经典武侠电影",
    movieIds: [12, 9, 2],
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20classic%20film%20collection%20artwork%20with%20traditional%20martial%20arts%20elements%2C%20ink%20wash%20painting%20style%20mountains%2C%20swords%20and%20ancient%20scrolls%2C%20elegant%20black%20white%20and%20red%20aesthetic&width=800&height=400&seq=collection-02&orientation=landscape",
  },
  {
    id: 3,
    title: "高能悬疑，烧脑推荐",
    description: "反转不断的悬疑佳作，让你看到最后一秒",
    movieIds: [5, 8, 3],
    imageUrl: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20collection%20with%20puzzle%20pieces%20and%20question%20marks%2C%20dark%20atmospheric%20design%2C%20blue%20and%20grey%20tones%2C%20intellectual%20suspense%20aesthetic%2C%20cinematographic%20moody%20composition&width=800&height=400&seq=collection-03&orientation=landscape",
  },
];